import React from 'react'

const About = () => {
  return (
    <div className="about_us">
      <h1>About Us</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque, in porro adipisci debitis, amet voluptas et voluptatibus, placeat blanditiis sed error ex quas quo quam quae asperiores maiores delectus dolorem?
      </p>
      <div className="about_store">
        <h2>Haram's Shop</h2>
        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eaque beatae facilis ipsum? Id, ab? Voluptatibus nobis quas, reprehenderit illo repudiandae quibusdam soluta praesentium obcaecati reiciendis expedita quasi ipsa animi ea. Ullam modi voluptas, temporibus fugit amet excepturi alias molestias obcaecati impedit ex deserunt earum harum et ab perferendis dolor quas!</p>
      </div>
      <div className="about_creator">
        <h2>About Haram Yoon</h2>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel, ad libero? Tempore voluptatum consectetur quasi voluptas neque quis laborum. Consectetur accusantium atque laudantium laboriosam placeat, sed optio culpa quibusdam assumenda quae porro corrupti officia fuga quas temporibus aperiam quod in est animi sequi. Expedita facilis commodi doloribus incidunt porro. Excepturi.</p>
      </div>
    </div>
  )
}

export default About
